<template>
  <Transition name="fade">
    <div v-if="isEditor.isOpen" class="card mb-4">
      <div class="card-header pb-0">
        <span class="font-weight-bolder" style="font-size: 22px; margin-right: 8px">Guest Editor </span>
        <span style="float: right">
          <argon-button v-if="this.$store.state.templateEditor.mode == 'viewTemplate'" @click="closeEditor()" id="changepwd" checked="true" color="secondary" variant="outline" class="mx-2" size="md">Back</argon-button>
          <argon-button v-if="isResetPass" @click="updatePassword()" color="success" size="md">Save Changes</argon-button></span
        >
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="p-0">
          <div class="px-4 m-0 row">
            <div class="card-header pb-0">
              <h6 class="d-inline">Guest Details</h6>
              <span v-if="this.$store.state.templateEditor.mode == 'createTemplate'" style="float: right">
                <argon-button @click="closeEditor()" id="changepwd" checked="true" color="secondary" variant="outline" class="mx-2" size="md">Cancel</argon-button>
                <argon-button @click="addNewGuest()" color="success" size="md">Create Guest</argon-button></span
              >
              <argon-switch v-if="this.$store.state.templateEditor.mode == 'viewTemplate'" @click="toggleResetPass()" id="resetPass" class="d-inline-block" name="Reset Password" style="margin-left: 12px"></argon-switch>
              <span v-if="this.$store.state.templateEditor.mode == 'viewTemplate'" style="position: relative; left: -8px" class="text-xs text-secondary">Reset Password Toggle</span>
              <hr />
            </div>
            <div v-if="this.$store.state.templateEditor.mode == 'viewTemplate' && !isResetPass" class="col-md-6">
              <label for="example-text-input" class="form-control-label">Full Name</label>
              <div class="px-1 font-weight-bold text-md">{{ this.$store.state.adminlist.rows[this.$store.state.templateEditor.requestedrow].full_name }}</div>
            </div>

            <div class="col-md-6">
              <label for="example-text-input" class="form-control-label">Full Name</label>
              <argon-input type="text" id="newFullName" v-model="creds.full_name" value="" placeholder="Enter new guest name" />
            </div>
            <div class="col-md-6">
              <label for="newGuestCategory" class="form-control-label">Category</label>
              <Multiselect v-model="this.categorySelector.value" id="newGuestCategory" name="newGuestCategory" mode="single" :close-on-select="true" :searchable="true" :options="categorySelector.options" />
            </div>
            <div class="col-md-6">
              <label for="example-text-input" class="form-control-label">Email</label>
              <argon-input type="email" id="newEmail" v-model="creds.email" value="" placeholder="Enter new email" />
            </div>
            <div class="col-md-6">
              <label for="example-text-input" class="form-control-label">Phone</label>
              <argon-input type="tel" id="newPhone" value="" v-model="creds.phone" placeholder="Enter new guest's phone number" />
            </div>

            <div class="col-md-12 pb-2">
              <label for="example-text-input" class="form-control-label">Guest Address</label>
              <!-- <ckeditor name="address" :editor="editor" v-model="guestAdress" :config="editorConfig"></ckeditor> -->
              <textarea v-model="creds.address" id="guestAddress" name="guestAddress" rows="3" style="display: block; width: 100%"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
  import ArgonInput from "@/components/ArgonInput.vue";
  import $ from "jquery";
  import ArgonButton from "@/components/ArgonButton.vue";
  import Multiselect from "@vueform/multiselect";
  import ArgonSwitch from "@/components/ArgonSwitch.vue";
  import "@vueform/multiselect/themes/default.css";
  import axios from "axios";
  import CKEditor from "@ckeditor/ckeditor5-vue";
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

  export default {
    name: "template-editor",
    props: {
      cardBg: String,
      selectedOption: {},
    },
    components: {
      ArgonInput,
      ArgonButton,
      ArgonSwitch,
      Multiselect,
      ckeditor: CKEditor.component,
    },
    data() {
      return {
        templatedata: {},
        selects: {},
        creds: {
          full_name: "",
          phone: "",
          email: "",
          address: "",
        },
        guestAdress: "",
        categorySelector: {
          value: "",
          options: [
            { value: "a", label: "Reguler" },
            { value: "b", label: "Man's Family" },
            { value: "c", label: "Woman's Family" },
            { value: "d", label: "VIP" },
            { value: "e", label: "VVIP" },
          ],
        },
        editor: ClassicEditor,
        editorConfig: {
          toolbar: [],
        },
        item: {
          id: 1,
          // both the commented out value and the
          // active value don't work
          // relatedItem: {
          //   value: 100,
          //   label: "test",
          // },
          relatedItem: 100,
        },
      };
    },
    computed: {
      isSuper() {
        return localStorage.getItem(sha256("isSuper").toString());
      },
      categoryOptions() {
        return this.categorySelector.options;
      },
      isEditor() {
        return this.$store.state.templateEditor;
      },
      gettemplateData() {
        return this.templatedata;
      },
      options() {
        return this.options;
      },
    },
    methods: {
      getRoute() {
        const routeArr = this.$route.path.split("/");
        return routeArr[1];
      },
      addNewGuest() {
        let JWTToken = localStorage.getItem("token");
        let creds = {
          full_name: $("#newFullName").val(),
          phone: $("#newPhone").val(),
          email: $("#newEmail").val(),
          address: $("#guestAddress").val(),
          guestCategoryId: this.categorySelector.value,
          eventId: 1,
        };

        axios
          .post("https://api.macra.co.id/mavent/guest/add", creds, { headers: { Authorization: `Bearer ${JWTToken}` } })
          .then((res) => {
            alert(res.data.message);
            location.reload();
          })
          .catch((err) => {
            console.log(creds);
            alert(err.message);
          });
      },
      getAllCategory() {
        let JWTToken = localStorage.getItem("token");

        axios
          .get("https://api.macra.co.id/mavent/guest-category/all", { headers: { Authorization: `Bearer ${JWTToken}` } })
          .then((res) => {
            let temp = [];
            for (const [category, row] of Object.entries(res.data)) {
              temp[category] = {
                value: row.id,
                label: row.name,
              };
            }

            this.categorySelector.options = temp;
          })
          .catch((err) => {
            alert(err.message);
          });
      },
      toggleResetPass() {
        console.log($("#changepwd").is("checked"));
        return (this.$store.state.templateEditor.resetPass = !this.$store.state.templateEditor.resetPass);
      },
      closeEditor() {
        this.$store.state.templateEditor.isOpen = false;
      },
      updatePassword() {
        if ($("#newpass").val() == $("#newpassconfirm").val()) {
          let JWTToken = localStorage.getItem("token");
          let cred = {
            password: $("#newpass").val(),
          };

          axios
            .patch("https://api.macra.co.id/mavent/admin/reset-password", cred, { headers: { Authorization: `Bearer ${JWTToken}` } })
            .then((res) => {
              alert(res.message);
            })
            .catch((error) => {
              alert(error);
            });
        } else {
          $("#newpass").prop("required", true);
          $("#newpassconfirm").prop("required", true);
          setTimeout(() => {
            $("#newpass").prop("required", false);
            $("#newpassconfirm").prop("required", false);
          }, 3000);
          return alert("Both passwords have to be the same");
        }

        event.preventDefault();
      },
      createGuest() {
        let JWTToken = localStorage.getItem("token");
        let cred = {
          full_name: $("#newfullname").val(),
          email: $("#newemail").val(),
          username: $("#newusername").val(),
          password: $("#newaccpwd").val(),
        };

        axios
          .post("https://api.macra.co.id/mavent/admin/add", cred, { headers: { Authorization: `Bearer ${JWTToken}` } })
          .then((res) => {
            alert(res.status);
          })
          .catch((error) => {
            alert(error);
          });
      },

      encrypt(ele) {
        return sha256(ele);
      },
      getAdminData(row) {
        return (this.templatedata = this.$store.state.adminlist.rows[row]);
      },
      async fetchOptions(search) {
        console.log(search);
        // hits an API
        // /api/items/search?search=${search}
        return new Promise((resolve) => {
          setTimeout(() => {
            if (search) {
              resolve([
                {
                  value: 100,
                  label: "test",
                },
                {
                  value: 101,
                  label: "test2",
                },
              ]);
            } else {
              resolve([]);
            }
          }, 200);
        });
      },
    },
    mounted() {
      // if (this.$store.state.templateEditor.requestedrow != null) {
      //   this.getAdminData(this.$store.state.templateEditor.requestedrow);
      // }
      this.getAllCategory();
    },
  };
</script>
